import { Fragment } from "react";

import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
// import Progress from "../component/sidebar/progress";
import Rating from "../component/sidebar/rating";
import axios from "axios";
import { useState, useEffect } from "react";
import LoadingSpinner from "../component/sidebar/loading-spinner";

// const name = "Emilee Logan";
// const degi = "Master of Education Degree";
// const desc =
//   "Infrastruct ntrinsicl grow optimal talers rather than efectve nformaon Collabora optimize partnersh and frictionles deliverables";
// const subTitle = "Personal Statement";
// const infoDetails =
// "Enthusa expedte clent focused growth strateg wherea clent centered infrastruct ntrinsicl grow optimal talers rather than efectve nformaon Collabora optimize partnersh and frictionles deliverables infrastructs ntrinsicl grow optimal talers rather efectve";
// const skillTitle = "Personal Language Skill";
// const awardTitle = "Recognitions Award";

const memInfoLisst = [
  {
    leftText: "Address",
  },
  {
    leftText: "Email",
  },
  {
    leftText: "Phone",
  },
  {
    leftText: "website",
  },
];

const memSocialList = [
  {
    iconName: "icofont-twitter",
    color: "#00acee",
    socialSiteName: "twitter",
  },
  {
    iconName: "icofont-instagram",
    color: "#e4405f",
    socialSiteName: "instagram",
  },
  {
    iconName: "icofont-facebook",
    color: "#3b5998",
    socialSiteName: "facebook",
  },
  {
    iconName: "icofont-linkedin",
    color: "#0072b1",
    socialSiteName: "linkedin",
  },
  {
    iconName: "icofont-youtube",
    color: "#f00",
    socialSiteName: "youtube",
  },
];

// const skillList = [
//   {
//     percentage: "80",
//     text: "English",
//   },
//   {
//     percentage: "70",
//     text: "Hindi",
//   },
//   {
//     percentage: "90",
//     text: "Bangla",
//   },
//   {
//     percentage: "50",
//     text: "Arabic",
//   },
// ];

// const awardList = [
//   {
//     imgUrl: "assets/images/instructor/single/icon/01.png",
//     imgAlt: "instructor",
//     text: "Award 2018",
//   },
//   {
//     imgUrl: "assets/images/instructor/single/icon/02.png",
//     imgAlt: "instructor",
//     text: "Award 2019",
//   },
//   {
//     imgUrl: "assets/images/instructor/single/icon/03.png",
//     imgAlt: "instructor",
//     text: "Award 2020",
//   },
//   {
//     imgUrl: "assets/images/instructor/single/icon/04.png",
//     imgAlt: "instructor",
//     text: "Award 2022",
//   },
// ];

const TeamSingle = () => {
  const [teamData, setTeamData] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        const id = searchParams.get("team_id");

        const teamIdForm = new FormData();
        teamIdForm.append("id", id);
        const response = await axios.post(
          "https://parivartanacademy.dealbill.net/api/find_team",
          teamIdForm
        );
        if (response.data.status) {
          setTeamData(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);
  if (!teamData) {
    return <LoadingSpinner />;
  }
  return (
    <Fragment>
      <Header />
      <PageHeader title={teamData.name} curPage={teamData.name} />
      <section className="instructor-single-section padding-tb section-bg">
        <div className="container">
          <div className="instructor-wrapper">
            <div className="instructor-single-top">
              <div className="instructor-single-item d-flex flex-wrap justify-content-between">
                <div className="instructor-single-thumb">
                  <img src={teamData.photo} alt={teamData.name} />
                </div>
                <div className="instructor-single-content">
                  <h4 className="title">{teamData.name}</h4>
                  <p className="ins-dege">{teamData.designation}</p>
                  <Rating type={"team"} typeId={teamData.id} />
                  <p className="ins-desc">{teamData.description}</p>
                  <h6 className="subtitle">{"Personal Statement"}</h6>
                  <p className="ins-desc">{teamData.description}</p>
                  <ul className="lab-ul">
                    {memInfoLisst.map((val, i) => {
                      if (teamData[val["leftText"].toLowerCase()]) {
                        return (
                          <li
                            className="d-flex flex-wrap justify-content-start"
                            key={i}
                          >
                            <span className="list-name">{val.leftText}</span>
                            <span className="list-attr">
                              {teamData[val["leftText"].toLowerCase()]}
                            </span>
                          </li>
                        );
                      } else {
                        return null;
                      }
                    })}
                    {!teamData.facebook ||
                      !teamData.instagram ||
                      !teamData.linkedin ||
                      !teamData.youtube ||
                      !teamData.twitter ? (
                      <></>
                    ) : (
                      <li className="d-flex flex-wrap justify-content-start">
                        <span className="list-name">Follow</span>
                        <ul className="lab-ul list-attr d-flex flex-wrap justify-content-start">
                          {memSocialList.map((val, i) => {
                            if (teamData[val["socialSiteName"]]) {
                              return (
                                <li key={i}>
                                  <a
                                    // className={val.className}
                                    href={teamData[val["socialSiteName"]]}
                                    style={{ color: `${val.color}` }}
                                  >
                                    <i className={val.iconName}></i>
                                  </a>
                                </li>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </ul>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="instructor-single-bottom d-flex flex-wrap mt-4">
                            <div className="col-xl-6 pb-5 pb-xl-0 d-flex flex-wrap justify-content-lg-start justify-content-between">
                                <h4 className="subtitle">{skillTitle}</h4>
                                {skillList.map((val, i) => (
                                    <div className="text-center skill-item" key={i}>
                                        <div className="skill-thumb">
                                            <Progress strokeWidth={8} percentage={val.percentage} />
                                        </div>
                                        <p>{val.text}</p>
                                    </div>
                                ))}
                            </div>
                            <div className="col-xl-6 d-flex flex-wrap justify-content-lg-start justify-content-between">
                                <h4 className="subtitle">{awardTitle}</h4>
                                {awardList.map((val, i) => (
                                    <div className="skill-item text-center" key={i}>
                                        <div className="skill-thumb">
                                            <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                        </div>
                                        <p>{val.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div> */}
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default TeamSingle;
